import { render, staticRenderFns } from "./fightCardMenu.vue?vue&type=template&id=c252a998"
import script from "./fightCardMenu.vue?vue&type=script&lang=js"
export * from "./fightCardMenu.vue?vue&type=script&lang=js"
import style0 from "./fightCardMenu.vue?vue&type=style&index=0&id=c252a998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports